// import external dependencies
import 'jquery';
import axios from 'axios';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import './filters';
import './entityPage';
import './form';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => {
  routes.loadEvents();

  jQuery('.toggle-menu').click(() => {
    $('.mobile-menu').toggleClass('open');
  });

  if (window.matchMedia("(max-width: 1024px)").matches) {
    const slider = jQuery('#homeSlider');

    if (slider) {
      slider.slick({
        dots: true,
        arrows: true,
        nextArrow: jQuery('#sliderNextArrowHome'),
        prevArrow: jQuery('#sliderPrevArrowHome'),
      });
    }
  }

  if (window.matchMedia("(max-width: 768px)").matches) {
    const blogSlider = jQuery('#blogSlider');

    if (blogSlider) {
      blogSlider.slick({
        slidesToShow: 1.2,
        arrows: false,
        infinite: false,
      });
    }

    const boxSlider = jQuery('#pageSlider');

    if (boxSlider) {
      boxSlider.slick({
        dots: false,

        slidesToShow: 1,
        nextArrow: $('#sliderNextArrow'),
        prevArrow: $('#sliderPrevArrow'),
      });
    }
  }

  const reviewSlider = jQuery('#reviewSlider');

  if (reviewSlider) {
    reviewSlider.slick({
      dots: false,
      arrows: false,
      // nextArrow: $('#sliderNextArrow'),
      // prevArrow: $('#sliderPrevArrow'),
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            arrows: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  // sliders for overview
  document.querySelectorAll('.slider-wrapper').forEach(slider => {
    jQuery(slider.querySelector('.slider')).slick({
      dots: false,
      //variableWidth: false,
      nextArrow: slider.querySelector('.sliderNext'),
      prevArrow: slider.querySelector('.sliderPrev'),
    });
  });
});

// jQuery(document).ready(function() {
//   var data = {
//     'action': 'my_action',
//     'whatever': ajax_object.we_value      // We pass php values differently!
//   };
//   // We can also pass the url value separately from ajaxurl for front end AJAX implementations
//   jQuery.post(ajax_object.ajax_url, data, function(response) {
//     alert('Got this from the server: ' + response);
//   });
// });

const placesAutocompleteInput = document.querySelector('.places-autocomplete');

if (placesAutocompleteInput) {
  const placesAutocompleteResults = document.querySelector('.places-autocomplete-results');

  let goTo = null;
  let goToName = null;
  let resultsObj = [];

  // eslint-disable-next-line
  function loadAutoComplete() {
    const params = {
      action: 'google_places_autocomplete',
    }

    axios.get('/wp-admin/admin-ajax.php', {
      params,
    }).then(({ data }) => {
      resultsObj = data;
    });
  }

  loadAutoComplete();


  if (window.matchMedia("(max-width: 768px)").matches) {
    const item = localStorage.getItem('search');

    if (item) {
      const data = JSON.parse(item);

      goTo = data.slug;
      goToName = data.name;
      placesAutocompleteInput.value = data.name;
    }
  }

  document.querySelector('.location-form').addEventListener('submit', function (e) {
    if (goTo && goToName.toLowerCase() === e.target.value.toLowerCase()) {
      e.preventDefault();
      window.location = goTo;
    }

    const isInResults = resultsObj.find(r => r.name.toLowerCase().includes(placesAutocompleteInput.value.toLowerCase()));
    if (isInResults) {
      e.preventDefault();
      localStorage.setItem('search', JSON.stringify({
        name: isInResults.name,
        slug: `/opslagruimtes/${isInResults.slug}`,
      }));
      window.location = `/opslagruimtes/${isInResults.slug}`;
    }
  });

  const zipcodeRegex = /\d{4}\s?\w{2}/gi;

  placesAutocompleteInput.addEventListener('keyup', function() {
    const { value } = placesAutocompleteInput;

    if (value.trim().length === 0) {
      placesAutocompleteResults.classList.add('hidden');
      return;
    }

    placesAutocompleteResults.classList.remove('hidden');
    const results = placesAutocompleteResults.querySelector('.result-list');
    results.innerHTML = '';

    let haasAdded = false;
    const resultsList = resultsObj.filter(r => r.name.toLowerCase().includes(value.toLowerCase()));

    if (resultsList.length > 0) {
      haasAdded = true;
      resultsList.forEach(location => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'p-4 text-gray-700 hover:bg-gray-100 w-full text-left';
        button.innerText = location.name;
        button.setAttribute('data-slug', `/opslagruimtes/${location.slug}`);

        results.appendChild(button);
      });
    }

    if (value.match(zipcodeRegex)) {
      haasAdded = true;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'p-4 text-gray-700 hover:bg-gray-100 w-full text-left';
      button.innerText = value;
      button.setAttribute('data-slug', `/locatie?zip=${value}`);

      results.appendChild(button);
    }

    if (!haasAdded) {
      const p = document.createElement('p');
      p.className = 'text-gray-700';
      p.innerText = 'Er zijn geen resultaten gevonden die voldoen aan uw zoekcriteria';

      results.appendChild(p);
    }
  });

  placesAutocompleteResults.querySelector('.result-list').addEventListener('click', function(event) {
    const { target } = event;
    const { localName, dataset, innerText } = target;

    if (localName !== 'button') {
      return;
    }

    if (window.matchMedia("(max-width: 768px)").matches) {
      localStorage.setItem('search', JSON.stringify({
        name: innerText,
        slug: dataset.slug,
      }))
    }

    window.location = dataset.slug;
  });
}


const faqItems = document.querySelectorAll('.faq-item');

if (faqItems) {
  faqItems.forEach(item => item.querySelector('button').addEventListener('click', () => {
    if (item.classList.contains('open')) {
      item.classList.remove('open');
      item.querySelector('p').classList.add('hidden');
      item.querySelector('svg').classList.add('rotate-180');
    } else {
      item.classList.add('open');
      item.querySelector('p').classList.remove('hidden');
      item.querySelector('svg').classList.remove('rotate-180');
    }
  }));
}

const mobileFiltersOpenBtn = document.getElementById('openMobileFilters');

if (mobileFiltersOpenBtn) {
  const filtersContainer = document.getElementById('filtersContainer');
  const classes = ['bg-white', 'fixed', 'h-full', 'left-0', 'top-0', 'w-full', 'z-50'];

  mobileFiltersOpenBtn.addEventListener('click', () => {
    filtersContainer.classList.remove('hidden');
    filtersContainer.classList.add(...classes);
  });

  document.getElementById('closeMobileFilters').addEventListener('click', () => {
    filtersContainer.classList.remove(...classes);
    filtersContainer.classList.add('hidden');
  });
}



// WEBPACK FOOTER //
// ./scripts/main.js